import { LOCAL_BROKER_BADGE } from '@/lib/localBroker';

/**
 * A fixed marker shown only in laptop local-broker builds (`VITE_LOCAL_BROKER=true`). The
 * counterpart of `PreviewBadge`, and it exists for the opposite reason.
 *
 * A preview build is dangerous because it looks live when it is not. A local-broker build is
 * dangerous because it *is* live — against a broker that is not the production one, holding
 * data somebody invented in Node-RED. A screenshot of it is indistinguishable from a real
 * display showing real occupancy, which is exactly the screenshot that ends up in a ticket.
 *
 * Blue rather than amber so the two modes are never confused at a glance, and they cannot
 * both be on (`@/lib/localBroker`, precedence).
 *
 * The fleet image (`VITE_LOCAL_BROKER=runtime`, SYM-503) is the same mode with runtime
 * credentials and IS the wall, so `LOCAL_BROKER_BADGE` is `false` there by construction —
 * there is no flag to get wrong.
 */
export function LocalBrokerBadge() {
  if (!LOCAL_BROKER_BADGE) return null;

  return (
    <div
      // Same positioning contract as `PreviewBadge`: never intercepts, clears the slider.
      className="pointer-events-none fixed top-0 right-0 z-[9999] rounded-bl bg-blue-700 px-2 py-1 font-mono text-xs text-white opacity-90"
      aria-hidden="true"
    >
      LOCAL BROKER · not production data
    </div>
  );
}
